import {
  Alert,
  Autocomplete,
  Button,
  CardActions,
  Dialog,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
} from '@mui/material';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { updateContraente } from '../../models/request';
import { getBrokerList } from '../../models/user';
import { AlertMessage } from '../../types/form';

type AssignBrokerDialogProps = {
  open: boolean;
  onClose: Function;
  contraente: any;
  setContraente: Function;
};

const PER_PAGE = 3;

const AssignBroker = ({
  open,
  onClose,
  contraente,
  setContraente,
}: AssignBrokerDialogProps) => {
  const [alertMessage, setAlertMessage] = useState<AlertMessage>(null);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [brokers, setBrokers] = useState();
  const [selectedBroker, setSelectedBroker] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (contraente?.user?.id) {
      setSelectedBroker(contraente?.user);
    }
  }, []);

  const fetchBrokerList = async (query: string) => {
    try {
      const res = await getBrokerList(query, undefined, PER_PAGE);
      if (res.status === 200) {
        setBrokers(res.data.data);
      } else {
        throw new Error('Unable to retrieve Broker list');
      }
    } catch (error) {
      console.error(`An error occurred while retrieving Broker list: ${error}`);
      setAlertMessage({
        severity: 'warning',
        message: "Non è stato possibile recuperare l'elenco dei Broker",
      });
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = async () => {
    // Skip if no Contraente is selected
    if (!contraente) return;
    setLoading(true);
    try {
      const res = await updateContraente(contraente?.id, {
        brokerId: selectedBroker?.id,
      });

      if (res.status === 200) {
        const updatedContraente = cloneDeep(contraente);

        updatedContraente.user = selectedBroker;
        setContraente(updatedContraente);

        setAlertMessage({
          severity: 'success',
          message: 'Contraente aggiornato con successo.',
        });
        setShowAlert(true);

        setTimeout(() => {
          setLoading(false);
          onClose();
        }, 3000);
      } else {
        throw new Error("Errore durante l'aggiornamento del Contraente.");
      }
    } catch (error) {
      setAlertMessage({
        severity: 'warning',
        message: 'Non è stato possibile aggiornare il Contraente.',
      });
      setShowAlert(true);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Assegna Utente</DialogTitle>
      <DialogContent sx={{ width: '300px' }}>
        <Autocomplete
          sx={{ my: 1 }}
          options={brokers || []}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          getOptionLabel={(option: any) => option?.fullname || ''}
          value={selectedBroker}
          onChange={(_, value) => {
            setSelectedBroker(value);
          }}
          onInputChange={(_, value) => {
            fetchBrokerList(value);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Broker" variant="outlined" />
          )}
        />
      </DialogContent>
      <CardActions>
        <Button sx={{ width: '100%' }} variant="outlined" onClick={handleClose}>
          Annulla
        </Button>
        <Button
          sx={{ width: '100%' }}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!selectedBroker || loading}
        >
          Conferma
        </Button>
      </CardActions>
      <Snackbar
        open={showAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={() => setShowAlert(false)}
      >
        <Alert severity={alertMessage?.severity}>{alertMessage?.message}</Alert>
      </Snackbar>
    </Dialog>
  );
};

export default AssignBroker;
